import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';
import { useTapped } from '@utils/hooks';
import { FooterMenuLink } from '@utils/types';

import ArrowIcon from './arrow.svg';

import style from './InfoLink.scss';

const cn = bemCssModules(style, 'InfoLink');

export type TInfoLink = {
  link: FooterMenuLink['link'];
  text: FooterMenuLink['text'];
};

const InfoLink: CustomFC<TInfoLink> = ({ link, text, className }) => {
  const { t } = useTranslation();

  const { handlers, isTapped } = useTapped();

  const href =
    link !== '/help'
      ? `https://mercuryo.io${link}?utm_source=my.mercuryo&utm_medium=referral`
      : 'https://help.mercuryo.io/hc/en-gb/sections/14494982716829-Getting-started-';

  return (
    <a
      className={cn({ isTapped }, [className])}
      href={href}
      rel="noreferrer"
      target="_blank"
      {...handlers}
    >
      {t(text)}
      <ArrowIcon className={cn('arrow')} />
    </a>
  );
};

export default InfoLink;
